import React from 'react'
import styled from 'styled-components'
import { bool } from 'prop-types'
import ScrollAnimation from 'react-animate-on-scroll'
import { rgba } from 'polished'

import { white, black } from 'styles/colors'
import { media } from 'styles/media'
import { navHeight, navHeightMobile } from 'styles/global'
import { H1, H3, fontWeights, lineHeights } from 'styles/typography'
import * as spacing from 'styles/spacing'

import Wrapper from 'components/Wrapper'
import Header from 'components/Header'
import Button from 'components/button/Button'

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
  background-image: url('${process.env.BASE_PATH}/images/home/callout-banner-mobile.jpg');
  background-size: 600px;
  background-position: top;
  background-repeat: no-repeat;
  background-color: #050505;
  padding-top: 200px;
  padding-bottom: 24px;
  margin-bottom: 32px;

  ${media.small`
    padding-top: 220px;
    padding-bottom: 32px;
    background-size: 100%;
    margin-bottom: 40px;
  `};

  ${media.medium`
    padding-top: 270px;
    margin-bottom: 56px;
    background-image: url('${process.env.BASE_PATH}/images/home/callout-banner.jpg');
    background-size: cover;
  `};

  ${media.large`
    padding-top: 300px;
    margin-bottom: 64px;
    padding-bottom: 40px;
  `};

  ${media.xLarge`
    margin-bottom: 80px;
    padding-top: 340px;
  `};

  ${media.xxLarge`
    background-position: top 15% center;
  `};
`

const HeaderWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${navHeightMobile};
  background-color: ${rgba(black, 0.8)};

  ${media.medium`
    height: ${navHeight};
  `};
`

const Inner = styled.div`
  position: relative;
  flex: 1;
`

const Heading = styled(H1)`
  text-transform: uppercase;
  font-family: 'Trim Poster';
  margin-bottom: ${spacing.medium};
  font-size: 48px;
  line-height: 0.95;
  color: ${white};
  text-shadow: 0px 0px 32px rgba(1, 0, 2, 0.4);

  ${media.small`
    font-size: 56px;
  `};

  ${media.medium`
    font-size: 64px;
    line-height: 0.9;
    max-width: 830px;
    margin-left: auto;
    margin-right: auto;
  `};

  ${media.large`
    font-size: 72px;
    max-width: 900px;
    margin-bottom: ${spacing.large};
  `};

  ${media.xLarge`
    max-width: 1040px;
    font-size: 80px;
  `};
`

const Subheading = styled(H3)`
  color: ${white};
  line-height: ${lineHeights.base};
  font-weight: ${fontWeights.regular};
  text-shadow: 0px 0px 32px rgba(1, 0, 2, 0.4);
  max-width: 340px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${spacing.large};

  ${media.small`
    max-width: 520px;
  `};

  ${media.medium`
    max-width: 710px;
  `};

  ${media.large`
    max-width: 820px;
    margin-bottom: ${spacing.xLarge};
  `};
`

const Disclaimer = styled.p`
  color: ${white};
  font-size: 10px;
  margin-top: ${spacing.large};

  a {
    text-decoration: underline;
    color: currentColor;
    font-weight: ${fontWeights.regular};
  }

  ${media.medium`
    font-size: 11px;
    margin-top: ${spacing.xxLarge};
  `};

  ${media.large`
    font-size: 12px;
    max-width: 1120px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 48px;
  `};

  ${media.xLarge`
    margin-top: 56px;
  `};
`

const StyledButton = styled(Button)`
  min-width: 200px;

  ${media.medium`
    min-width: 240px;
  `};

  ${media.large`
    min-width: 270px;
  `};
`

const CreativeCallout = ({ hideHeader }) => (
  <Container>
    {!hideHeader && (
      <HeaderWrap>
        <Header transparent />
      </HeaderWrap>
    )}
    <Inner>
      <Wrapper>
        <Heading as={ScrollAnimation} animateIn="fadeInUp" delay={0} offset={0} animateOnce>
          It's time to vote for your favourite skin designs
        </Heading>
        <Subheading as={ScrollAnimation} animateIn="fadeInUp" delay={200} offset={0} animateOnce>
          10 FINALISTS. 3 WINNING DESIGNS. YOU DECIDE THE WINNERS OF THE VUSE SKINS DESIGN CHALLENGE, AND THE NEXT
          LIMITED EDITION SKINS COLLECTION FOR ePod.
        </Subheading>
        <ScrollAnimation animateIn="fadeInUp" delay={400} offset={0} animateOnce>
          <StyledButton to="/challenge/" size="large" theme="custom" customColor={white} variant="outline">
            Vote now
          </StyledButton>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={600} offset={0} animateOnce>
          <Disclaimer>
            No purchase necessary. The Contest begins on October 1st, 2020 at 4:00 p.m. ET and ends on October 23rd,
            2020 at 4:00 p.m. ET. Open to residents of Canada, excluding Quebec, Nova Scotia, North West Territories,
            Yukon and Nunavut, who are registered vuse.com members, who are nicotine consumers and who have reached the
            legal age to purchase vaping products in their province of residence. Prizes: twenty (20) prizes to be won,
            each Prize consisting of one (1) prepaid payment card valued at $50 CAD and three (3) limited edition ePod
            skins. Odds of winning depend on number of entries received and skill in meeting criteria. Internet access
            and math skills test required. Contest Rules:{' '}
            <a href="https://challenge.vuse.com/rules-voter-contest" target="_blank" rel="noreferrer">
              challenge.vuse.com/rules-voter-contest
            </a>
            .
          </Disclaimer>
        </ScrollAnimation>
      </Wrapper>
    </Inner>
  </Container>
)

CreativeCallout.propTypes = {
  hideHeader: bool
}

export default CreativeCallout
